// extracted by mini-css-extract-plugin
export var measureBox = "_48-0";